class productFAQs {
  constructor(parent) {
    if (!parent) return;
    this.parent = parent;
    this.init();
  }

  setMaxHeight(content) {
    content.style.maxHeight = 'none';
    content.offsetHeight;

    requestAnimationFrame(() => {
      content.style.maxHeight = content.scrollHeight + 'px';
    });
  }

  clickEvent = () => {
    const items = this.parent.querySelectorAll('.faqs-item');

    items.forEach((item, index) => {
      const button = item.querySelector('.item-heading');
      const content = item.querySelector('.faqs-item-content');

      if (index < 3) {
        item.classList.add('open');
        requestAnimationFrame(() => {
          this.setMaxHeight(content);
        });
      }

      button.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');

        if (index < 3) {
          if (isOpen) {
            item.classList.remove('open');
            item.querySelector('.faqs-item-content').style.maxHeight = null;
          } else {
            item.classList.add('open');
            this.setMaxHeight(content);
          }
        } else {
          items.forEach(el => {
            el.classList.remove('open');
            el.querySelector('.faqs-item-content').style.maxHeight = null;
          });
          
          item.classList.add('open');
          this.setMaxHeight(content);
        }
      });
    });
  }

  init = () => {
    window.addEventListener('load', () => {
      this.clickEvent();
    });
  }
}

new productFAQs(document.querySelector('.section-product-faqs'));
